import React, { useState } from 'react';

/**
 * Avatar component con fallback a iniciales
 * Muestra imagen o iniciales del nombre si falta avatarUrl
 */
const Avatar = ({ name, avatarUrl, size = 'md', className = '' }) => {
  const [imgError, setImgError] = useState(false);

  // Extraer iniciales del nombre
  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const names = fullName.trim().split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    return names[0].substring(0, 2).toUpperCase();
  };

  // Tamaños predefinidos
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };

  const sizeClass = sizes[size] || sizes.md;

  // Si no hay avatar o hubo error, mostrar iniciales
  if (!avatarUrl || imgError) {
    const initials = getInitials(name);
    const bgColor = `hsl(${(name?.charCodeAt(0) || 0) * 137.5 % 360}, 50%, 40%)`;

    return (
      <div
        className={`${sizeClass} ${className} rounded-full flex items-center justify-center font-semibold text-white`}
        style={{ backgroundColor: bgColor }}
        title={name}
      >
        {initials}
      </div>
    );
  }

  // Mostrar imagen
  return (
    <img
      src={avatarUrl}
      alt={`Foto de ${name}`}
      className={`${sizeClass} ${className} rounded-full object-cover border-2 border-white/10`}
      onError={() => setImgError(true)}
      loading="lazy"
      decoding="async"
    />
  );
};

export default Avatar;
